/* ═══ "Send to Workspace" (My Products) — SATU takrifan hantaran ═══════════
   Butang ini WAJIB berkelakuan SAMA seperti pemilih "Add Product" dalam
   Workspace (ProductLibraryModal), kerana kedua-duanya menyuap jambatan yang
   SAMA dalam App.jsx (handleHeaderAddProduct):

   1. PENDING tidak boleh dihantar. Pemilih mengunci produk PENDING
      (hasIntelligence false) — produk tanpa data produk tidak boleh dijana.
      ⭐ Keputusan user 2026-09-22 (pilihan b): ada SATU pun PENDING dalam
      pilihan = TIADA apa dihantar. Pelanggan buang tanda PENDING dahulu.

   2. Produk dihantar PENUH, bukan salinan ringkas. Pemilih menghantar doc item
      penuh dan jambatan memilih medan yang ia perlukan.
      ⛔ Versi lama menyalin 11 medan satu persatu dan tertinggal dua:
         · `intelligenceJson` inline — cara Import (extension + webapp) MASIH
           menyimpan data produk begini: 85% item READY (diukur 2026-09-22).
           Jambatan hanya mencari subdoc payload, jumpa kosong, dan kad lahir
           TANPA data → Generate dilangkau "tiada data produk". Senyap, sejak
           butang ini lahir 22 Ogos (≥96 kad / 18 pelanggan).
         · `extraImageUrls` — gambar tambahan untuk Flow tercicir.
      Jadi hantaran = doc penuh TOLAK senarai kecil medan yang tiada pembaca
      di Workspace. Medan baharu pada item kelak ikut sampai dengan sendiri.

   3. Doc dibaca SEGAR dari pangkalan data, bukan salinan dalam halaman.
      Selepas "Lengkapkan data", data inline DIPADAM di pangkalan data (pindah
      ke subdoc payload) tetapi salinan halaman masih membawanya — menghantar
      salinan itu = kad dapat data produk LAMA. Pemilih pula sentiasa segar
      (onSnapshot).

   ⚠️ KEMBAR: pembaca hantaran = effect "Hantar ke Workspace" dalam App.jsx
      (memakai KUNCI_HANTAR_WORKSPACE dari fail ini). Peraturan PENDING =
      `selectableIds` dalam ProductLibraryModal.jsx. Ubah satu, semak semua.
   ═══════════════════════════════════════════════════════════════════════════ */

export const KUNCI_HANTAR_WORKSPACE = 'sesaat_stage_to_workspace';
export const HAD_HANTAR_WORKSPACE = 20;

/* Medan item yang TIDAK dihantar: tiada pembaca di Workspace, dan `scrapedData`
   ialah medan paling berat (~6KB, maks ~14KB setiap item — diukur 2026-09-22). */
const MEDAN_TIDAK_DIHANTAR = ['scrapedData'];

/** Produk yang belum READY — peraturan SAMA dengan kunci PENDING pemilih. */
export function produkPending(senarai) {
    return (Array.isArray(senarai) ? senarai : []).filter(p => !p?.hasIntelligence);
}

/** Salinan item untuk dihantar: doc penuh tolak medan yang tiada pembaca. */
export function bentukHantaran(item) {
    const salinan = { ...item };
    for (const k of MEDAN_TIDAK_DIHANTAR) delete salinan[k];
    return salinan;
}

/**
 * Baca semula setiap produk dari pangkalan data, kemudian sediakan hantaran.
 * Produk yang sudah tiada, atau kini bukan READY, MENYEKAT seluruh hantaran
 * (peraturan yang sama seperti PENDING dalam pilihan).
 *
 * @param {object[]} senarai  produk terpilih (salinan halaman — untuk id + nama)
 * @param {(id:string)=>Promise<object|null>} bacaItem  pulangkan doc segar {id,...} atau null
 * @returns {Promise<{ok:true, produk:object[]} | {ok:false, berubah:object[]}>}
 *          Bacaan yang GAGAL (rangkaian, kebenaran) dilontar — pemanggil memaparkannya.
 */
export async function sediakanHantaran(senarai, bacaItem) {
    const asal = Array.isArray(senarai) ? senarai : [];
    const segar = await Promise.all(asal.map(p => bacaItem(p.id)));
    const berubah = [];
    const produk = [];
    segar.forEach((item, i) => {
        if (!item || !item.hasIntelligence) { berubah.push(asal[i]); return; }
        produk.push(bentukHantaran({ ...item, id: asal[i].id }));
    });
    return berubah.length > 0 ? { ok: false, berubah } : { ok: true, produk };
}

/** Nama ringkas untuk mesej: `maks` nama pertama (dipotong 40 aksara) + bilangan baki. */
export function namaRingkas(senarai, maks = 3) {
    const semua = (Array.isArray(senarai) ? senarai : [])
        .map(p => {
            const s = String(p?.name || p?.id || '').trim();
            return s.length > 40 ? s.slice(0, 40).trimEnd() + '…' : s;
        })
        .filter(Boolean);
    return { nama: semua.slice(0, maks), baki: Math.max(0, semua.length - maks) };
}
